import { createAsyncThunk } from '@reduxjs/toolkit';
import { teamsCreateChat } from '../../../services/teamsChat';
import { ITeamsCreateChatPayload } from '../../../services/teamsChat/types';

export const ThunkCreateTeamsChat = createAsyncThunk(
  'teamsChat/createTeamsChat',
  async (payload: ITeamsCreateChatPayload) => teamsCreateChat(payload).then(r => r.data),
);

export default {};
